//Modules
import { useParams, Link, useLocation } from 'react-router-dom'

//Components
import Nav from '../widgets/Nav/Nav'
import PhotoGallery from '../widgets/PhotoGallery';

//Utils
import useFetch from '../utils/useFetch';

//Variables
const { REACT_APP_IPBNEWS_EP, REACT_APP_IPBNEWS_NEWS, REACT_APP_IPBNEWS_URL_IMG } = process.env

function NoticiaDetalhe() {
  let { slugNews } = useParams();
  const id = slugNews.split('-')
  let history = useLocation()
  const lang = history.pathname.substring(1,3)

  const { data: newsItem } = useFetch(`${REACT_APP_IPBNEWS_EP}${REACT_APP_IPBNEWS_NEWS}&id=${id[id.length-1]}`)

  return (
      <>          
        {newsItem && 
          <>
            <div className="container-fluid sticky-top nav-bb" style={{backgroundColor: "white", zIndex: "9999"}}>
              <Nav dest={false} content={false} subItem={false}/>
            </div>
            <div className="container newsItem">
              <div className="newsItemWrapper">
                <Link to={lang === "pt" ?
                  (history?.state && history.state.from === "/pt") ? "/pt" : "/pt/noticias"
                  : (history?.state && history.state.from === "/en") ? "/en" : "/en/news"
                }><span className="material-icons-outlined newsBack">arrow_back</span></Link>
                <h1 id='titleBar'>{newsItem[0].titulo}</h1>
                <span className="newsDate"> 
                  {new Date(newsItem[0].data).toLocaleDateString("pt-PT", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                  })}
                </span>                                
                <img className="newsItemImage" src={`${REACT_APP_IPBNEWS_URL_IMG}${newsItem[0].foto}`}
                alt="NoticiaImg" />
                <p className="newsResumo">{newsItem[0].resumo}</p>
                <p className="newsTexto" dangerouslySetInnerHTML={{__html: newsItem[0].texto}}></p>
                {newsItem[0].link_video && <div dangerouslySetInnerHTML={{__html:newsItem[0].link_video}}></div>}

                {newsItem[0]?.galeria && newsItem[0].galeria !== "" && <PhotoGallery id_gallery={newsItem[0].galeria} titulo={newsItem[0].titulo} />}

              </div>
            </div>
          </>} 
      </>
  )
}

export default NoticiaDetalhe
